﻿import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";

export class CZ07_2014 extends BaseForm
{
	override updateForm()
	{

	}
}